/* unplugin-vue-components disabled */import script from "./update.vue?vue&type=script&setup=true&lang=js"
export * from "./update.vue?vue&type=script&setup=true&lang=js"

import "./update.vue?vue&type=style&index=0&id=23da5cde&lang=scss"

const __exports__ = script;

export default __exports__